import {Component,OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {ActivatedRouteSnapshot,NavigationEnd,RouteConfigLoadEnd,RouteConfigLoadStart,Router,Event as RouterEvent} from '@angular/router';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {Account,LoginModalService,Principal} from 'src/app/core';
import {StateStorageService} from 'src/app/core/auth/state-storage.service';
import {SpotShipmentDeclarationService} from 'src/app/shared/spot-certificate/spot-shipment-declaration.service';
import {Clients} from 'src/environments/clients';
import {environment} from 'src/environments/environment';
import {LoaderService} from '../loader/loader.service';
declare var $: any;

@Component({
    selector: 'jhi-main',
    templateUrl: './main.component.html'
})
export class JhiMainComponent implements OnInit {
    account: Account;
    role: any;
    isPublicState = false;
    showOutlet = false;
    dynamicPopupShow = true;
        navSubscription: any;
    navbarShow:boolean=true;
    subscription: Subscription;
    supportIcon:boolean=true

    login=environment.login;


    constructor(
        private stateStorageService: StateStorageService,
        private titleService: Title,
        private router: Router,
        public principal: Principal,
        private loginModalService: LoginModalService,
        public activeModal: NgbActiveModal,
        private translate: TranslateService,
        private loaderService:LoaderService,
        private spotShipmentDeclarationService:SpotShipmentDeclarationService
    ) {
        router.events.subscribe(
            ( event: RouterEvent ) : void => {
                this.principal.sortColumn = "";
                this.principal.reverseSort = false;
                this.principal.applySorting = false;
                // see also
                //  console.log(val instanceof NavigationEnd,"NavigationEnd")

                let url = window.location.href;
                if ((url.indexOf("certificate-verification") > -1) || (url.indexOf("verify-certificate") > -1) ||  (url.indexOf("instructions/wi") > -1) ||
                 (url.indexOf("instructions/mi") > -1) || (url.indexOf("instructions/bi") > -1) || (url.indexOf("instructions/si") > -1)) {
                    this.navbarShow = false;
                }
                if (window.location.href.includes('/user-guide')) {
                    this.navbarShow = false;
                }
                //  console.log("route navigation process start")
                if ( event instanceof RouteConfigLoadStart ) {
                    this.loaderService.show();
                     //  console.log("route navigation start")
                } else if ( event instanceof RouteConfigLoadEnd ) {
                    this.loaderService.hide();
                    //  console.log("route navigation END")
                }

            }
        );


    }

    private getPageTitle(routeSnapshot: ActivatedRouteSnapshot) {
        let title: string = routeSnapshot.data && routeSnapshot.data['pageTitle'] ? routeSnapshot.data['pageTitle'] : 'Marine';
        if (routeSnapshot.firstChild) {
            title = this.getPageTitle(routeSnapshot.firstChild) || title;
        }
        return title;
    }


    ngOnInit() {
        //  console.log("main page");
         // This is METHOD for mail trigering
        //  const source = interval(600000);
        //  this.subscription = source.subscribe(val => this.sendSpotDataForMailTriger());

        // setTimeout(function() {
        //     this.activeModal.dismiss('cancel');
        //     this.activeModal.dismiss(true);
        // }, 4000);

        // if(this._swUpdate.isEnabled) {
        //     this._swUpdate.checkForUpdate();
        //     this._swUpdate.available.subscribe(update => {
        //       if(update.type == 'UPDATE_AVAILABLE') {
        //         location.reload();
        //     }
        //     });
        //   }

        let url= window.location.href;

        if(url.includes("/#/verify-certificate")){
         this.router.navigateByUrl("/verify-certificate")
        }



        if (this.stateStorageService.getLanguageKey()) {
            this.translate.setDefaultLang(this.stateStorageService.getLanguageKey());
        } else {
            this.translate.setDefaultLang('en');
        }


        let logo='../../../assets/images/icons/favicon.ico'
        let favIcon: HTMLLinkElement=document.querySelector('#appIcon');
        favIcon.href = logo;
        if(this.login==Clients.VERHEYEN) {
            logo='../../../assets/images/verheyen/favicon.ico'
            favIcon.href = logo;
        } else if(this.login==Clients.ATRALO) {
            logo='../../../assets/images/Atralo/favicaon.ico'
            favIcon.href=logo;
        }


        //  console.log(this.principal);
        this.navSubscription = this.router.events.subscribe(event => {
            // if (event instanceof RouteConfigLoadStart) {
            //     this.loadingRouteConfig = true;
            // } else if (event instanceof RouteConfigLoadEnd) {
            //     this.loadingRouteConfig = false;
            // }
            if (event instanceof NavigationEnd) {
                this.titleService.setTitle('TDIS | '+ this.getPageTitle(this.router.routerState.snapshot.root));
                if (
                    this.router.routerState.snapshot.url === '/verify-certificate' ||
                    this.router.routerState.snapshot.url === '/instructions/mi' ||
                    this.router.routerState.snapshot.url === '/instructions/wi' ||
                    this.router.routerState.snapshot.url === '/instructions/si' ||
                    this.router.routerState.snapshot.url === '/reset/request' ||
                    this.router.routerState.snapshot.url.includes('/reset/finish') ||
                    this.router.routerState.snapshot.url === '/instructions/bi' ||  this.router.routerState.snapshot.url === '/instructions/mi'
                ) {
                    this.isPublicState = true;
                } else {
                    this.isPublicState = false;
                }
                this.navSubscription.unsubscribe();
            }

        });

        if (this.router.routerState.snapshot.url === '/accessdenied') {
            this.router.navigate(['/login']);
        }

        // if (url.includes('/login')) {
        //     this.supportIcon = false
        // }
        // this.role = this.principal;

        if (this.isAuthenticated()) {
            this.dynamicPopupShow = false;
        }
        $(document).ready(function() {
            $(document).on('click', 'ng-multiselect-dropdown', function() {
                $(this)
                    .find('.filter-textbox')
                    .find('input')
                    .focus();
            });
           //  console.log = function () { }
        });
    }

     data = {
        email :'',
        requestDataWithUrl :'',
    }
    //for mail triggger
    // sendSpotDataForMailTriger(){
    //     let certificateData =this.stateStorageService.getLocalStorageDataWithExpiry("spotCertificateDTOForMail");
    //     let parsedData =  JSON.parse(certificateData);
    //     this.data.email=  parsedData.spotClientEmailId;
    //     let encodedUri=   encodeURIComponent(certificateData);
    //     this.data.requestDataWithUrl =encodedUri
    //     this.spotShipmentDeclarationService.emailService( this.data,"/mail-trigger").subscribe(res =>{
    //         console.log("mail trigeer ",res);

    //     });

    //     // let decodedUri=   decodeURIComponent(encodedUri);
    //     // console.log("decodedUri",decodedUri);
    //     // let unparsed =  JSON.parse(decodedUri);
    //     // console.log("decodedUri",unparsed);
    //     console.log("text");
    //   //  return "final123";


    // }
    // ngOnDestroy() {
    //     this.subscription && this.subscription.unsubscribe();
    // }

    // onActivate(event: any) {
    //     this.showOutlet = true;
    // }

    // onDeactivate(event: any) {
    //     this.showOutlet = false;
    // }

    isAuthenticated() {
        return this.principal.isAuthenticated();
    }

    receiveMessage(event) {
        this.isPublicState = event;
        this.isAuthenticated();
    }
    /* open(){
        let url=window.location.href;
        const policyText = url.includes("policy");
        const viewText = url.includes("view");
        if (policyText && viewText && document.getElementById("futrure-histroy-window")) {
            this.principal.isHistoryFuturePopupShown=false;
            this.principal.showContent=false;
        }
        // else if(!this.principal.isHistoryFuturePopupShown && document.getElementById("futrure-histroy-window")){
        //     document.getElementById("futrure-histroy-window").style.display = "block";
        //     this.principal.isHistoryFuturePopupShown=true
        // }
    } */
}
